const workflowManagementStyle = {

};

export default workflowManagementStyle;